import { TTranslate } from 'src/types/main';
import { ICustomTooltipProps } from '~/view/components/Controls/CustomTooltip/CustomTooltip';

export const TextPreset = {
  CUSTOM: 'custom',
  SECTION_HEADER: 'section-header',
  BLOCK_HEADER: 'block-header',
  SWITCHER_LABEL: 'switcher-label',
  COLUMN_TITLE: 'column-title',
  LIST_ROW: 'list-row',
  DONATABLE_IN_LIST: 'donatable-in-list',
  ERROR: 'error',
  RECOMMENDATION: 'recommendation',
  CART_OPTION: 'cart-option',
  ORDER_FIELD: 'order-field',
  MODAL_MESSAGE: 'modal-message',
  TITLE_INSIDE_INPUT: 'title-inside-input',
} as const;
export type TTextPreset = TValueOf<typeof TextPreset>;

export interface ITextProps {
  dir?: 'rtl' | 'ltr';
  type: TTextPreset;
  text: TTranslate | string | number | null | undefined;
  tooltip?: (Partial<ICustomTooltipProps> & { iconSize?: number }) | null;
  // className keys
  error?: boolean;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  wrapperClassName?: string;
  // text keys
  quantity?: number;
  noTranslate?: boolean;
  defaultValue?: string;
  style?: React.CSSProperties;
}
